import React, { use, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import DepartmentChart from "../components/DepartmentChart";
import CardStats from "../components/CardStats";
import {
  EmployeeLeaderboardTable,
  LeaderboardTable,
  SupervisorLeaderboardTable,
} from "../components/LeaderboardTable";
import {
  FaCalendarAlt,
  FaCalendarDay,
  FaCalendarWeek,
  FaExpandArrowsAlt,
} from "react-icons/fa";
import { APICall } from "../Utls/Api";
import ExpertiseChart from "./ExpertiseChart";
import { useSelector } from "react-redux";

const DashboardHome = () => {
  const [data, setData] = useState(null);
  const [leaderboardData, setLeaderboardData] = useState(null);
  const [employeesLeaderboard, setEmployeeLeaderboard] = useState(null);
  const [matrixData, setMatrixData] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [viewType, setViewType] = useState("daily"); // 'daily', 'weekly' or 'monthly'
  const [loading, setLoading] = useState(false);
  const [fullscreenLeaderboard, setFullscreenLeaderboard] = useState(null);
  const user = useSelector((state) => state.user.user);
  const isSuperadmin = user?.user_type === "superadmin";
  const getDashbordData = async () => {
    const res = await APICall("/auth/getUserCounts", "GET", "");
    if (res.status) {
      setData(res.data);
    }
  };

  const getEmployeeLeaderBoard = async (type = viewType) => {
    setLoading(true);
    try {
      const res = await APICall(
        `/dashboard/employee/leaderborad?type=${type}`,
        "GET",
        ""
      );
      console.log(res);
      if (res.status) {
        setEmployeeLeaderboard(res.data);
        if (res.data.dateRange) {
          setDateRange(res.data.dateRange);
        }
      }
    } catch (error) {
      console.error("Error fetching employee leaderboard:", error);
    } finally {
      setLoading(false);
    }
  };

  const getLeaderBoardData = async (type = viewType) => {
    setLoading(true);
    try {
      const res = await APICall(`/dashboard?type=${type}`, "GET", "");
      if (res.status) {
        setLeaderboardData(res.data);
        if (res.data.dateRange) {
          setDateRange(res.data.dateRange);
        }
      }
    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMartix = async (type = viewType) => {
    setLoading(true);
    try {
      const res = await APICall(
        `/dashboard/department-metrics?type=${type}`,
        "GET",
        ""
      );
      console.log(res.data);
      if (res.status) {
        setMatrixData(res.data?.metrics);
        if (res.data.dateRange) {
          setDateRange(res.data.dateRange);
        }
      }
    } catch (error) {
      console.error("Error fetching matrix data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewTypeChange = (type) => {
    setViewType(type);
    // Refresh all data with new type
    getLeaderBoardData(type);
    getEmployeeLeaderBoard(type);
    getMartix(type);
  };

  const formatDateRange = () => {
    if (!dateRange) return "";
    if (dateRange.type === "daily") {
      return `Today (${dateRange.start})`;
    } else {
      return `${dateRange.start} to ${dateRange.end}`;
    }
  };

  useEffect(() => {
    getDashbordData();
    getLeaderBoardData();
    getEmployeeLeaderBoard();
    getMartix();
  }, []);

  return (
    <Container fluid className="px-0">
      {/* Header with Type Selector */}
      <div className="box p-4 py-3">
        <Row className="align-items-center mb-3">
          <Col lg={8}>
            <h4 className="fw-semibold mb-0">Dashboard Overview</h4>
            {dateRange && (
              <small className="text-muted">
                <FaCalendarAlt className="me-2" />
                Data for: {formatDateRange()}
              </small>
            )}
          </Col>
          <Col lg={4} className="text-end">
            <ButtonGroup>
              <Button
                variant={viewType === "daily" ? "primary" : "outline-primary"}
                onClick={() => handleViewTypeChange("daily")}
                disabled={loading}
                size="sm"
              >
                <FaCalendarDay className="me-2" />
                Daily
              </Button>
              <Button
                variant={viewType === "weekly" ? "primary" : "outline-primary"}
                onClick={() => handleViewTypeChange("weekly")}
                disabled={loading}
                size="sm"
              >
                <FaCalendarWeek className="me-2" />
                Weekly
              </Button>
              <Button
                variant={viewType === "monthly" ? "primary" : "outline-primary"}
                onClick={() => handleViewTypeChange("monthly")}
                disabled={loading}
                size="sm"
              >
                <FaCalendarAlt className="me-2" />
                Monthly
              </Button>
            </ButtonGroup>
          </Col>
        </Row>

        {/* Stats Row */}
        <Row>
          {/* {user.user_type === "admin" && (
            <Col lg={2}>
              <h6 className="fw-semibold">Total No. Of Managers</h6>
              <h2 className="fw-semibold">{data?.managers || 0}</h2>
            </Col>
          )} */}
          <Col lg={2} className="mt-3 mt-lg-0">
            <h6 className="fw-semibold">Total No. Of Employees</h6>
            <h2 className="fw-semibold">{data?.employees || 0}</h2>
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <h6 className="fw-semibold">Total No. Of Supervisors</h6>
            <h2 className="fw-semibold">{data?.supervisors || 0}</h2>
          </Col>
          <Col lg={6} className="mt-3 mt-lg-0">
            <h6 className="fw-semibold">
              {user?.user_type === "superadmin"
                ? "The Highest Productive Manager Name"
                : "The Highest Productive Department Name"}
              <small className="text-muted ms-2">({viewType})</small>
            </h6>
            <h2 className="fw-semibold">
              {loading ? (
                <span className="text-muted">Loading...</span>
              ) : (
                leaderboardData?.topDepartment || "not listed"
              )}
            </h2>
          </Col>
          <Col lg={6} className="mt-3 mt-lg-0 pt-3">
            <h6 className="fw-semibold">
              Top Performer Employee
              <small className="text-muted ms-2">({viewType})</small>
            </h6>
            <h2 className="fw-semibold text-capitalize">
              {loading ? (
                <span className="text-muted">Loading...</span>
              ) : (
                <>
                  {employeesLeaderboard?.topPerformer?.employeeName ||
                    "not listed"}{" "}
                  {employeesLeaderboard?.topPerformer?.department &&
                    `(${employeesLeaderboard.topPerformer.department})`}
                </>
              )}
            </h2>
          </Col>
        </Row>
      </div>

      {/* Charts and Data */}
      <Row>
        <Col lg={6} className="mt-4">
          <Card className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">Department Workload</h6>
              <small className="text-muted">{viewType}</small>
            </div>
            {loading ? (
              <div className="text-center py-4">
                <span className="text-muted">Loading chart data...</span>
              </div>
            ) : (
              <DepartmentChart
                title="Workload"
                data={matrixData?.load || []}
                number={20}
                chartType="load"
              />
            )}
          </Card>
        </Col>

        <Col lg={6} className="mt-4">
          <Card className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">Department Productivity</h6>
              <small className="text-muted">{viewType}</small>
            </div>
            {loading ? (
              <div className="text-center py-4">
                <span className="text-muted">Loading chart data...</span>
              </div>
            ) : (
              <DepartmentChart
                title="Productivity"
                data={matrixData?.productivity || []}
                number={20}
                chartType="productivity"
              />
            )}
          </Card>
        </Col>

        <Col lg={6} className="mt-4">
          <Card className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">Department Stress</h6>
              <small className="text-muted">{viewType}</small>
            </div>
            {loading ? (
              <div className="text-center py-4">
                <span className="text-muted">Loading chart data...</span>
              </div>
            ) : (
              <DepartmentChart
                title="Stress"
                data={matrixData?.stress || []}
                number={10}
                chartType="stress"
              />
            )}
          </Card>
        </Col>

        <Col lg={6} className="mt-4">
          <Card className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">Department Wrmsd</h6>
              <small className="text-muted">{viewType}</small>
            </div>
            {loading ? (
              <div className="text-center py-4">
                <span className="text-muted">Loading chart data...</span>
              </div>
            ) : (
              <DepartmentChart
                title="Wrmsd"
                data={matrixData?.wrmsd || []}
                number={10}
                chartType="wrmsd"
              />
            )}
          </Card>
        </Col>

        <Col lg={6} className="mt-4">
          <h5 className="fw-semibold mb-2" style={{ fontSize: "18px" }}>
            Department Productivity & Workload
            <small className="text-muted ms-2">({viewType})</small>
          </h5>
          {loading ? (
            <Card className="p-3">
              <div className="text-center py-4">
                <span className="text-muted">Loading...</span>
              </div>
            </Card>
          ) : (
            <CardStats
              data1={matrixData?.load || []}
              data2={matrixData?.productivity || []}
              data1Type="load"
              data2Type="productivity"
              title1="Workload"
              title2="Productivity"
              show={true}
            />
          )}
        </Col>

        <Col lg={6} className="mt-4">
          <h5 className="fw-semibold mb-2" style={{ fontSize: "18px" }}>
            Department Stress & Wrmsd
            <small className="text-muted ms-2">({viewType})</small>
          </h5>
          {loading ? (
            <Card className="p-3">
              <div className="text-center py-4">
                <span className="text-muted">Loading...</span>
              </div>
            </Card>
          ) : (
            <CardStats
              data1={matrixData?.stress || []}
              data2={matrixData?.wrmsd || []}
              data1Type="stress"
              data2Type="wrmsd"
              title1="Stress"
              title2="WRMSDs"
              show={true}
            />
          )}
        </Col>

        <Col lg={12} className="mt-4">
          <Card className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">Department Expertise Levels</h6>
              <small className="text-muted">{viewType}</small>
            </div>
            {loading ? (
              <div className="text-center py-4">
                <span className="text-muted">Loading chart data...</span>
              </div>
            ) : (
              <ExpertiseChart
                title="Expertise Levels"
                data={matrixData?.expertise || []}
              />
            )}
          </Card>
        </Col>

        <Col lg={6} className="mt-4">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h5 className="fw-semibold mb-0" style={{ fontSize: "18px" }}>
              {user?.user_type === "superadmin" ?
                "Manager Leaderboard"
                : "Department Leaderboard"
              }
              <small className="text-muted ms-2">({viewType})</small>
            </h5>
            <Button
              variant="outline-secondary"
              size="sm"
              className="d-flex align-items-center justify-content-center"
              title="Open department leaderboard in fullscreen"
              onClick={() => setFullscreenLeaderboard("department")}
            >
              <FaExpandArrowsAlt />
            </Button>
          </div>
          {loading ? (
            <Card className="p-3">
              <div className="text-center py-4">
                <span className="text-muted">Loading leaderboard...</span>
              </div>
            </Card>
          ) : (
            <LeaderboardTable
              data={leaderboardData?.departmentLeaderboards || []}
            />
          )}
        </Col>

        {isSuperadmin && (
          <Col lg={6} className="mt-4">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h5 className="fw-semibold mb-0" style={{ fontSize: "18px" }}>
                Supervisor Leaderboard
                <small className="text-muted ms-2">({viewType})</small>
              </h5>
              <Button
                variant="outline-secondary"
                size="sm"
                className="d-flex align-items-center justify-content-center"
                title="Open supervisor leaderboard in fullscreen"
                onClick={() => setFullscreenLeaderboard("supervisor")}
              >
                <FaExpandArrowsAlt />
              </Button>
            </div>
            {loading ? (
              <Card className="p-3">
                <div className="text-center py-4">
                  <span className="text-muted">Loading leaderboard...</span>
                </div>
              </Card>
            ) : (
              <SupervisorLeaderboardTable
                data={leaderboardData?.supervisorLeaderboards || []}
              />
            )}
          </Col>
        )}

        <Col lg={6} className="mt-4">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h5 className="fw-semibold mb-0" style={{ fontSize: "18px" }}>
              Employee Leaderboard
              <small className="text-muted ms-2">({viewType})</small>
            </h5>
            <Button
              variant="outline-secondary"
              size="sm"
              className="d-flex align-items-center justify-content-center"
              title="Open employee leaderboard in fullscreen"
              onClick={() => setFullscreenLeaderboard("employee")}
            >
              <FaExpandArrowsAlt />
            </Button>
          </div>
          {loading ? (
            <Card className="p-3">
              <div className="text-center py-4">
                <span className="text-muted">Loading leaderboard...</span>
              </div>
            </Card>
          ) : (
            <EmployeeLeaderboardTable
              data={employeesLeaderboard?.employeeLeaderboard || []}
            />
          )}
        </Col>
      </Row>

      <Modal
        show={Boolean(fullscreenLeaderboard)}
        onHide={() => setFullscreenLeaderboard(null)}
        fullscreen
        className="dashboard-fullscreen-modal"
        backdropClassName="dashboard-fullscreen-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fullscreenLeaderboard === "department"
              ? isSuperadmin
                ? "Manager Leaderboard"
                : "Department Leaderboard"
              : fullscreenLeaderboard === "supervisor"
                ? "Supervisor Leaderboard"
                : "Employee Leaderboard"}
            <small className="text-muted ms-2">({viewType})</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          {loading ? (
            <div className="text-center py-4">
              <span className="text-muted">Loading leaderboard...</span>
            </div>
          ) : fullscreenLeaderboard === "department" ? (
            <LeaderboardTable
              data={leaderboardData?.departmentLeaderboards || []}
            />
          ) : fullscreenLeaderboard === "supervisor" ? (
            <SupervisorLeaderboardTable
              data={leaderboardData?.supervisorLeaderboards || []}
            />
          ) : (
            <EmployeeLeaderboardTable
              data={employeesLeaderboard?.employeeLeaderboard || []}
            />
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default DashboardHome;
